import { EnableReservationsResult as EnableReservationsResultDto } from 'gleblu-socket-api';

import EnableReservationsResult from '../interfaces/EnableReservationsResult';

export function fromDto(dto: EnableReservationsResultDto): EnableReservationsResult {
  return EnableReservationsResult[dto];
}

export function toDto(_: EnableReservationsResult): EnableReservationsResultDto {
  throw new Error('Not supported');
}
